import gql from "graphql-tag";

export const featuredCardsGQL = gql`
  query FeaturedCardQuery($input: FeaturedCardQueryInput) {
    featuredCards(input: $input) {
      total
      items {
        assets
        data {
          ... on LinkFeaturedCardData {
            __typename
            redirectUrl
          }
          ... on PathFeaturedCardData {
            __typename
            internalPath
          }
          ... on TournamentFeaturedCardData {
            __typename
            tournaments {
              id
              status
              game {
                category
                description
                data
                developer
                featured
                hasBattle
                hasTournament
                hasSolo
                id
                metadata
                orientation
                pegiAge
                pegiContent
                publisher
                rotationMode
                status
                title
                type
              }
            }
          }
          ... on GameFeaturedCardData {
            __typename
            game {
              category
              description
              developer
              featured
              hasBattle
              hasSolo
              hasTournament
              id
              metadata
              orientation
              pegiAge
              pegiContent
              publisher
              status
              type
              title
            }
          }
        }
        group
        id
        linkType
        metadata
        position
        title
      }
    }
  }
`;
